// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RL9F4oi1rvgbb0Z1dZqg {\n\tbackground: #1d39c4;\n}\n", "",{"version":3,"sources":["webpack://./client/src/components/styles/UserCircle.module.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;AACpB","sourcesContent":[".avatar {\n\tbackground: #1d39c4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": "RL9F4oi1rvgbb0Z1dZqg"
};
export default ___CSS_LOADER_EXPORT___;
